import {
    type CornCropMonitoring,
    CROP_MONITORING_KEYS,
    type CropMonitoring,
    type CropType,
} from '../types/crop-monitoring';

// Utility functions
export const getCropMonitoringKey = (crop: CropType): keyof CropMonitoring => {
    return CROP_MONITORING_KEYS[crop];
};

export const getCropMonitoringData = (cropMonitoring: CropMonitoring | undefined) => {
    if (!cropMonitoring) return;
    const key = getCropMonitoringKey(cropMonitoring.crop);
    return cropMonitoring[key] as CornCropMonitoring;
};

/**
 * True while an active corn CM may still be processed asynchronously on the server
 * (e.g. weather/GDU job after create or update). Used to drive short-lived SWR polling.
 */
export const cropMonitoringPendingAsyncState = (cropMonitoring: CropMonitoring | undefined): boolean => {
    if (!cropMonitoring?.active) return false;
    if (cropMonitoring.crop !== 'corn') return false;
    const corn = cropMonitoring.cornCropMonitoring;
    if (!corn) return true;
    if (corn.phenology === 'harvested') return false;
    return !corn.accumulatedGduDate;
};

export const isFallowPeriod = (plantingDate: string): boolean => {
    return new Date(plantingDate) > new Date();
};
